import { materials2050ApiFp } from "api-client";
import { SelectedItems } from "features/MappingTools/BuildingProductEditor/EPDSearch2050/Filters/FiltersMenu";
import { makeAutoObservable } from "mobx";
import { buildingProductStore } from "./BuildingProductStore";

class EPDSearchStore {
  selectedFilters: SelectedItems[] = [];
  fetchingEPDsLoading: boolean = false;

  setSelectedFilters(selectedFilters: SelectedItems[]) {
    this.selectedFilters = selectedFilters;
  }

  setFetchingEPDsLoading(fetchingEPDsLoading: boolean) {
    this.fetchingEPDsLoading = fetchingEPDsLoading;
  }

  async fetch2050FilterCategories() {
    return await materials2050ApiFp()
      .importerApiV1RoutersMaterials2050ListFilterCategories()
      .then((response) => response.data)
      .catch((error) => console.log(error, "error.fetchFilterCategories"));
  }

  async fetch2050FilterChildren(
    categoryID: string,
    searchTerm: string,
    page?: number,
    pageSize?: number
  ) {
    return await materials2050ApiFp()
      .importerApiV1RoutersMaterials2050SearchFilterOptions(
        categoryID,
        searchTerm,
        page,
        pageSize
      )
      .then((response) => response.data);
  }

  async fetch2050EPDs(term?: string, page?: number, pageSize?: number) {
    this.setFetchingEPDsLoading(true);
    const filters = this.selectedFilters.map((f) => ({
      category_key: String(f.category.value),
      ids: f.items.map((rec) => Number(rec.id)),
    }));
    return await materials2050ApiFp()
      .importerApiV1RoutersMaterials2050SearchMaterial2050Epds(
        { search_term: term ?? "", filters: filters },
        page,
        pageSize
      )
      .then((response) => response.data)
      .finally(() => this.setFetchingEPDsLoading(false));
  }

  async fetch2050EPDDetails(epd_id: string) {
    return await materials2050ApiFp()
      .importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails(epd_id)
      .then((response) => response.data);
  }

  async import2050EPD(epd_id: string) {
    return await materials2050ApiFp()
      .importerApiV1RoutersMaterials2050ImportEpd(epd_id)
      .then((response) => response.data);
  }

  handleSelect2050EPD = async (
    epd_id: string,
    datasetIndex: number,
    rowIndex: number
  ) => {
    const res = await epdSearchStore.import2050EPD(epd_id);
    if (res) buildingProductStore.onSelectEPDRow(res, datasetIndex, rowIndex);
    return res;
  };

  constructor() {
    makeAutoObservable(this);
  }

  static instance: EPDSearchStore;

  static getInstance(): EPDSearchStore {
    if (!EPDSearchStore.instance) {
      EPDSearchStore.instance = new EPDSearchStore();
    }
    return EPDSearchStore.instance;
  }
}

export const epdSearchStore = EPDSearchStore.getInstance();
